import { Injectable } from '@angular/core';
import 'rxjs/add/observable/forkJoin';
import { Observable } from 'rxjs/Observable';
import { HotelExtraInfoDao } from '../daos/hotel-extra-info.dao';
import { HotelDao } from '../daos/hotel.dao';
import { ServiceError } from '../model/errors/service-error.model';
import { Hotel } from '../model/hotel/hotel.model';
import { BaseService } from './base.service';
import { HotelModelBuilder } from './builders/hotel.model.builder';
import { LogService } from './logging.service';
import { ServiceErrorMapper } from './mapper/service-error.mapper';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';

const HOTEL_CACHE_DURATION = 10 * 60 * 1000; // 10 mins
const CLASS_NAME = 'HotelService';

@Injectable()
export class HotelService extends BaseService <Hotel, string> {
  private _hotelObservables: Map<string, Observable<Hotel>>;

  constructor(
    private _hotelDao: HotelDao,
    private _hotelExtraInfoDao: HotelExtraInfoDao,
    private _log: LogService
  ) {
    super(new ServiceErrorMapper(), HOTEL_CACHE_DURATION);
    this._hotelObservables = new Map<string, Observable<Hotel>>();
  }

  getHotel(hotelMnemonic: string, useCache: boolean = false): Observable<Hotel> {
    return this.getByKey(hotelMnemonic, useCache);
  }

  protected getFreshObservable(hotelMnemonic: string): Observable<Hotel> {
    return Observable.forkJoin(
      this._hotelDao.getHotel(hotelMnemonic),
      this._hotelExtraInfoDao.get(hotelMnemonic).pipe(catchError(error => of(error)))
    ).map((data) => {
      return new HotelModelBuilder().withHotelData(data[0]).withHotelExtraPoliciesData(data[1]).build();
    }).catch((error) => {
      const serviceError: ServiceError = this.mapError(error);
      this._log.error(`Error when getting hotel ${hotelMnemonic}`, CLASS_NAME, serviceError);
      return Observable.throw(serviceError);
    });
  }

  protected generateKey(hotelMnemonic: string): string {
    return hotelMnemonic;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/hotel.service.ts